// AppWithRouter.js
import React from 'react';
import { BrowserRouter as Router } from 'react-router-dom';

import { ThemeProvider } from './context/ThemeContext';
//import { AuthProvider } from './api/AuthContext';
import { NotificationProvider } from './context/NotificationContext';
import App from './App';
import { Provider } from 'react-redux';
import store, { persistor } from './redux/store';
import { PersistGate } from 'redux-persist/integration/react';
import Spinner from './features/Spinner';

const AppWithRouter = () => (
  <Provider store={store}>
    <PersistGate loading={<Spinner fullscreen />} persistor={persistor}>
      <ThemeProvider>
        <NotificationProvider>
          <Router>
            <App />
          </Router>
        </NotificationProvider>
      </ThemeProvider>
    </PersistGate>
  </Provider>
);

export default AppWithRouter;
